import type { FocusEvent } from "react";

export const handleDivBlur = (
  event: FocusEvent<HTMLDivElement>,
  onBlur?: () => void
) => {
  if (!onBlur) return;

  const nextFocusedElement = event.relatedTarget;

  if (
    nextFocusedElement instanceof Node &&
    event.currentTarget.contains(nextFocusedElement)
  ) {
    return;
  }

  onBlur();
};
